module.exports = fox._r("images/press/icon-social-fb.png", __webpack_public_path__ + "_/common/images/press/icon-social-fb.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-social-fb.png
// module id = 386
// module chunks = 2